// Recharts theming for the admin dashboard — locks every chart into the
// Carmen brand language: navy ink, rose accent, navy-tinted grid lines.

export const CS_COLORS = {
  rose: "#e11d48",
  roseDark: "#be123c",
  navy: "#0c3f6b",
  navySoft: "#3d7099",
  emerald: "#10b981",
  amber: "#f59e0b",
  cyan: "#4cc7ef",
  red: "#cd322c",
  ivory: "#fcfbf7",
} as const;

export const CHART_AXIS = {
  tick: { fontSize: 10, fontFamily: "Geist Mono, ui-monospace, monospace", fill: "rgba(10,52,96,0.62)" },
  stroke: "rgba(10,52,96,0.20)",
};

export const CHART_GRID = {
  stroke: "rgba(10,52,96,0.08)",
  strokeDasharray: "4 4",
};

export const CHART_TOOLTIP = {
  contentStyle: {
    background: "rgba(255,255,255,0.96)",
    backdropFilter: "blur(8px)",
    border: "1px solid rgba(10,52,96,0.10)",
    borderRadius: 12,
    boxShadow: "0 12px 28px rgba(10,52,96,0.10)",
    fontSize: 12,
    fontFamily: "Geist, ui-sans-serif, system-ui",
    color: CS_COLORS.navy,
    padding: "8px 10px",
  },
  labelStyle: {
    color: CS_COLORS.navy,
    fontWeight: 600,
  },
  itemStyle: {
    color: CS_COLORS.navy,
    fontFamily: "Geist Mono, ui-monospace, monospace",
  },
};

export const CHART_LEGEND = {
  wrapperStyle: {
    fontSize: 11,
    fontFamily: "Geist, ui-sans-serif, system-ui",
    color: "rgba(10,52,96,0.78)",
    paddingTop: 8,
  },
};

// Series palette ordered for stable assignment across pies/bars.
export const SERIES_PALETTE = [
  CS_COLORS.rose,
  CS_COLORS.navy,
  CS_COLORS.emerald,
  CS_COLORS.amber,
  CS_COLORS.cyan,
  CS_COLORS.navySoft,
  CS_COLORS.roseDark,
  CS_COLORS.red,
] as const;
